import React, { useEffect, useState } from "react";
import Content from "../../../../Components/Dashboard/Content/Content";
import Loader from "../../../../Utils/Loader";
import { useLocation } from "react-router-dom";

// import FullDataTable from "../../../../Components/ExtraComponents/Datatable/FullDataTable";
import Table from "../../../../Components/ExtraComponents/Tables/FullDataTable";

import { useDispatch } from "react-redux";
import { Transcation_Licence } from "../../../../ReduxStore/Slice/Admin/LicenceSlice";
import {
  get_year_and_month_only,
  fDateTimeSuffix,
} from "../../../../Utils/Date_formet";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";

const AllLicence = () => {
  const dispatch = useDispatch();

  const location = useLocation();
  var dashboard_filter = location.search.split("=")[1];

  const token = JSON.parse(localStorage.getItem("user_details")).token;
  const [getAllClients, setAllClients] = useState({ loading: true, data: [] });
  const [getAllClients1, setAllClients1] = useState({
    loading: true,
    data: [],
  });
  const [CountLicence, setCountLicence] = useState("");
  const [usedLicence, setUsedLicence] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [ForPanelStartDate, setForPanelStartDate] = useState("");
  const [ForShowTotalLicence, setForShowTotalLicence] = useState("");
  const [ForShowUsedLicence, setForShowUsedLicence] = useState(0);
  const [isSpinning, setIsSpinning] = useState(false);

  var headerName = "Transaction Licence";

  const columns = [
    {
      name: "User Name",
      selector: (row) => row.user?.UserName,
      cell: (row) => (
        <div
          className={`${row.admin_license ? "text-success fw-bold" : ""
            } d-flex align-items-center`}
          style={{
            fontWeight: row.admin_license ? "700" : "500",
            transition: "all 0.3s ease",
          }}
        >
          <div
            className={`me-2 rounded-circle`}
            style={{
              width: "8px",
              height: "8px",
              backgroundColor: row.admin_license ? "#198754" : "#0d6efd",
              // animation: "pulse 2s infinite",
            }}
          ></div>
          {row.user?.UserName || "-"}
        </div>
      ),
      sortable: true,
      // width: "180px",
    },
    {
      name: "License",
      selector: (row) => row.license || row.admin_license,
      cell: (row) => (
        <div className="d-flex align-items-center">
          <span
            className={`badge ${row.admin_license ? "bg-success" : "bg-primary"
              } fs-6 px-3 py-2`}
            style={{
              borderRadius: "20px",
              fontWeight: "600",
              letterSpacing: "0.5px",
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              transition: "transform 0.2s ease",
            }}
            onMouseEnter={(e) => (e.target.style.transform = "scale(1.05)")}
            onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
          >
            {row.license || row.admin_license || "-"}
          </span>
        </div>
      ),
      sortable: true,
      // width: "150px",
    },
    {
      name: "Created At",
      selector: (row) => row.createdAt,
      cell: (row) => (
        <div
          className={`${row.admin_license ? "text-success" : ""
            } d-flex align-items-center`}
          style={{
            fontSize: "0.9rem",
            fontWeight: "500",
          }}
        >
          <i
            className="fas fa-calendar-alt me-2"
            style={{ fontSize: "0.8rem" }}
          ></i>
          {row.createdAt ? fDateTimeSuffix(row.createdAt) : "-"}
        </div>
      ),
      sortable: true,
      // width: "240px",
    },
  ];

  const data = async () => {
    try {
      const response = await dispatch(Transcation_Licence({ token })).unwrap();

      if (response.status) {
        const { data: responseData, used_licence, total_licence } = response;

        setForShowUsedLicence(used_licence);
        setForShowTotalLicence(total_licence);
        setForPanelStartDate(
          fDateTimeSuffix(responseData[responseData.length - 1].createdAt)
        );

        let filteredData = responseData;

        if (dashboard_filter !== undefined) {
          filteredData = responseData.filter((item) => {
            const getMonthAndYear = get_year_and_month_only(item.createdAt);
            if (dashboard_filter === "0" || dashboard_filter === 0) {
              return (
                item.admin_license &&
                (!CountLicence || getMonthAndYear === CountLicence)
              );
            } else if (dashboard_filter === "1" || dashboard_filter === 1) {
              return (
                !item.admin_license &&
                (!CountLicence || getMonthAndYear === CountLicence)
              );
            }
          });
        }

        if (searchInput) {
          filteredData = filteredData.filter((item) =>
            item.user.UserName.toLowerCase().includes(searchInput.toLowerCase())
          );
        }

        setAllClients1({
          loading: false,
          data: filteredData,
        });

        setAllClients({
          loading: false,
          data: filteredData,
        });
      } else {
        setAllClients({
          loading: false,
          data: [],
        });
      }
    } catch (error) {
      setAllClients({ loading: false, data: null });
    }
  };

  useEffect(() => {
    data();
  }, [searchInput]);

  const ThisMonthUsedLicence = (val) => {
    // if (dashboard_filter === undefined) {
    if (getAllClients1.data !== undefined) {
      let filteredData = getAllClients1.data;

      if (val) {
        filteredData = filteredData.filter((item) => {
          const getMonthAndYear = get_year_and_month_only(item.createdAt);
          return getMonthAndYear === val;
        });
      } else {
        filteredData = getAllClients1.data;
      }

      setAllClients({ loading: false, data: filteredData });

      const totalLicenses = filteredData.reduce((accumulator, currentValue) => {
        return accumulator + (parseInt(currentValue.license) || 0);
      }, 0);

      setUsedLicence(totalLicenses);
    }
    // }
  };

  const resetFilter = (e) => {
    e.preventDefault();
    setUsedLicence("");
    setSearchInput("");
    setAllClients({
      loading: false,
      data: getAllClients1.data,
    });
    setCountLicence("");
  };

  if (dashboard_filter === "1") {
    headerName = "Used License";
  } else if (dashboard_filter === "0") {
    headerName = "Total License";
  }



  return (
    <>
      <style>{`
        @keyframes pulse {
          0%,
          100% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
        }

        @keyframes slideInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes fadeInScale {
          from {
            opacity: 0;
            transform: scale(0.9);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }

        .enhanced-card-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
          gap: 1.5rem;
          margin-bottom: 2rem;
          // animation: slideInUp 0.8s ease-out;
        }

        .enhanced-info-card {
          border: none;
          border-radius: 16px;
          padding: 1.5rem;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          position: relative;
          overflow: hidden;
          border-left: 4px solid transparent;
        }

        .enhanced-info-card::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 4px;
          background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
          transform: scaleX(0);
          transition: transform 0.3s ease;
        }

        .enhanced-info-card:hover::before {
          transform: scaleX(1);
        }

        .enhanced-info-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
        }

        .enhanced-info-card:nth-child(1) {
          border-left-color: #667eea;
        }
        .enhanced-info-card:nth-child(2) {
          border-left-color: #10b981;
        }
        .enhanced-info-card:nth-child(3) {
          border-left-color: #f59e0b;
        }
        .enhanced-info-card:nth-child(4) {
          border-left-color: #ef4444;
        }
        .enhanced-info-card:nth-child(5) {
          border-left-color: #8b5cf6;
        }

        .enhanced-info-card h6 {
          color: #6b7280;
          font-size: 0.875rem;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          margin-bottom: 0.5rem;
        }

        .enhanced-info-card div:last-child {
     
          font-size: 0.9rem;
          font-weight: 700;
          line-height: 1.2;
        }

        .enhanced-search-container {
          position: relative;
          // animation: fadeInScale 0.6s ease-out 0.2s both;
        }

   

        .enhanced-image-container {
          position: relative;
          border-radius: 20px;
          overflow: hidden;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          padding: 2rem;
          // animation: fadeInScale 0.8s ease-out 0.6s both;/
        }

        .enhanced-image-container::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(
            45deg,
            rgba(255, 255, 255, 0.1) 25%,
            transparent 25%,
            transparent 75%,
            rgba(255, 255, 255, 0.1) 75%
          );
          background-size: 20px 20px;
          // animation: move 20s linear infinite;
        }

        @keyframes move {
          0% {
            background-position: 0 0;
          }
          100% {
            background-position: 20px 20px;
          }
        }

        .enhanced-image-container img {
          width: 100%;
          height: auto;
          border-radius: 12px;
          filter: brightness(1.1) contrast(0.3);
          transition: transform 0.3s ease;
        }

        .enhanced-image-container:hover img {
          transform: scale(1.05);
        }

        .enhanced-table-container {
       
          border-radius: 20px;
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
          overflow: hidden;
          // animation: fadeInScale 0.8s ease-out 0.8s both;
          border: 1px solid #e5e7eb;
        }

        .enhanced-table-header {
          background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
          padding: 1.5rem;
          border-bottom: 1px solid #e5e7eb;
        }

        .enhanced-table-header h5 {
          margin: 0;
          color: #1f2937;
          font-weight: 700;
          font-size: 1.25rem;
        }

        .enhanced-table-header p {
          margin: 0.5rem 0 0 0;
          color: #6b7280;
          font-size: 0.9rem;
        }
   

      `}</style>

      <Content Page_title={headerName} Filter_tab={true} button_status={false}>
        <div className="row flex filter-row align-items-end mb-4">
          {dashboard_filter !== undefined ? (
            ""
          ) : (
            <>
              <div className="enhanced-card-grid">
                <div
                  className="enhanced-info-card"
                  style={{ animationDelay: "0.1s" }}
                >
                  <h6>Start Date</h6>
                  <div>{ForPanelStartDate || "--"}</div>
                </div>

                <div
                  className="enhanced-info-card"
                  style={{ animationDelay: "0.2s" }}
                >
                  <h6>Total Licence</h6>
                  <div>{ForShowTotalLicence || 0}</div>
                </div>

                <div
                  className="enhanced-info-card"
                  style={{ animationDelay: "0.3s" }}
                >
                  <h6>Used Licence</h6>
                  <div>{ForShowUsedLicence || 0}</div>
                </div>

                <div
                  className="enhanced-info-card"
                  style={{ animationDelay: "0.4s" }}
                >
                  <h6>Remaining Licence</h6>
                  <div>
                    {Number.isFinite(ForShowTotalLicence) &&
                      Number.isFinite(ForShowUsedLicence)
                      ? ForShowTotalLicence - ForShowUsedLicence
                      : 0}
                  </div>
                </div>
              </div>
            </>
          )}

          <div className="col-lg-3 col-md-6 col-6">
            <div className="">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label fw-semibold"
              >
                Search Something Here
              </label>
              <input
                type="text"
                placeholder="Search users..."
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
                className="form-control enhanced-search-input"
                id="exampleFormControlInput1"
              />
            </div>
          </div>

          <div className="col-lg-3 col-6">
            <div className=" row d-flex flex-column">
              <label
                htmlFor="validationCustom05"
                className="form-label fw-semibold "
              >
                Please Select Month
              </label>
              <div className="col-lg-12 align-items-center d-flex">
                <DatePicker
                  selected={
                    CountLicence ? new Date(CountLicence + "-01") : null
                  }
                  onChange={(date) => {
                    setCountLicence(format(date, "yyyy-MM"));
                    ThisMonthUsedLicence(format(date, "yyyy-MM"));
                  }}
                  dateFormat="yyyy-MM"
                  showMonthYearPicker
                  placeholderText="Select month"
                  className="form-control"
                  maxDate={new Date()}
                />
              </div>
            </div>
          </div>
          <div className="col-lg-3">
            <button
              className="btn btn-primary btn-sm"
              title="Reset Filters"
              onClick={(e) => {
                e.preventDefault();
                setIsSpinning(true);
                resetFilter(e); // reset filters
                setTimeout(() => {
                  data(); // re-fetch table data
                  setIsSpinning(false);
                }, 1000);
              }}
            >
              <i className={`fa fa-refresh ${isSpinning ? "spin" : ""}`}></i>
            </button>
          </div>

          {usedLicence && (
            <div className="col-lg-3 ">
              <h6>Current Month Licence</h6>
              <div>{usedLicence || "Please Select Month"}</div>
            </div>
          )}
        </div>

        {getAllClients?.loading ? (
          <Loader />
        ) : (
          <div className="">
            <div className="row">
              {/* <div className="col-lg-5">
                <div className="enhanced-image-container">
                  <div className="text-center mb-3">
                    <h5 className="fw-bold mb-2">
                      License Analytics
                    </h5>
                    <p className="mb-0">
                      Visual representation of your license management
                    </p>
                  </div>
                  <img
                    src="\assets\images\Checklist-light.png"
                    className="card-img-top"
                    alt="Client Statistics"
                    style={{ position: "relative", zIndex: 2 }}
                  />
                </div>
              </div> */}

              <div className="col-lg-12">
                <div className="enhanced-table-container position-relative">
                  {getAllClients.loading || isSpinning ? (
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ height: "300px" }}
                    >
                      <Loader />
                    </div>
                  ) : (
                    <Table columns={columns} data={getAllClients?.data || []} />
                  )}
                </div>

              </div>
            </div>
          </div>
        )}
      </Content>
    </>
  );
};

export default AllLicence;
